import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02ed40a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "report-submit"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-submit__content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "report-submit__content-title" }, "Отправить отчёт в Max Бота"),
  /*#__PURE__*/_createElementVNode("p", { class: "report-submit__content-info" }, " Отчёт стоит отправлять только после его полного заполнения, дальнейшие попытки отправки пациент не получит ")
], -1))
const _hoisted_3 = { class: "report-submit__footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Привязать пациента ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Отправить ")
const _hoisted_6 = {
  key: 2,
  class: "report-submit__already-send"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "report-submit__content-title" }, "Привязка к боту", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog__subtitle" }, [
  /*#__PURE__*/_createTextVNode(" *QR-код нужно отсканировать пациенту "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" для привязки к боту ")
], -1))
const _hoisted_9 = ["src"]

import {
  computed,
  ref,
  onUnmounted,
  watch,
} from 'vue'
import { reportApi } from '@/shared/api/report/report.api'
import { useRoute } from 'vue-router'
import { showErrorMessage } from '@/shared/utils'
import { ElDialog } from 'element-plus'
import { brushReportApi, patientApi, screeningReportApi } from '@/shared/api'
import { SendReportToTelegramBot } from '@/shared/types'

interface Props {
  isLinked: boolean
  isSended: boolean
  reportName: 'plaqueIndex' | 'brushMap' | 'screening'
}

interface ReportsImplementsSendReportToTelegramBot {
  plaqueIndex: SendReportToTelegramBot
  brushMap: SendReportToTelegramBot
  screening: SendReportToTelegramBot
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isLinked: { type: Boolean },
    isSended: { type: Boolean },
    reportName: null
  },
  emits: ['updateLinkedStatus', 'updateSendedStatus'],
  setup(__props: any, { emit }) {

const props = __props as {
  isLinked: boolean
  isSended: boolean
  reportName: 'plaqueIndex' | 'brushMap' | 'screening'
}





const route = useRoute()
const reportId = computed(() => route.params.reportId)
const patientId = computed(() => route.params.patientId)
const isLoading = ref(false)
const isShowDialog = ref(false)

const getAPIByReportName: ReportsImplementsSendReportToTelegramBot = {
  plaqueIndex: reportApi,
  brushMap: brushReportApi,
  screening: screeningReportApi,
}

async function sendReportToTelegramBot() {
  isLoading.value = true

  const reportAPI = getAPIByReportName[props.reportName]

  const [error, _] = await reportAPI.sendReportToTelegramBot(
    Number(reportId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    emit('updateSendedStatus')
  }

  isLoading.value = false
}

let intervalCheck

async function linkPatientToBot() {
  isShowDialog.value = true
  setIntervalCheckLinkedToBot()
}

function setIntervalCheckLinkedToBot() {
  intervalCheck = setInterval(checkLinkedToBot, 5000)
}

async function checkLinkedToBot() {
  const [error, response] = await patientApi.getPatientInfo(
    Number(patientId.value)
  )

  if (error) {
    showErrorMessage(error)
    clearInterval(intervalCheck)
    return
  }

  if (response.data.patient.sent_to_bot === 1) {
    clearInterval(intervalCheck)
    isShowDialog.value = false
    emit('updateLinkedStatus')
  }
}

watch(isShowDialog, () => {
  if (!isShowDialog.value) {
    clearInterval(intervalCheck)
  }
})

onUnmounted(() => {
  if (intervalCheck) {
    clearInterval(intervalCheck)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (Number(_unref(reportId)) && Number(_unref(patientId)))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (!__props.isLinked)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: linkPatientToBot,
                type: "primary",
                round: "",
                loading: isLoading.value
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["loading"]))
            : (!__props.isSended)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  onClick: sendReportToTelegramBot,
                  type: "primary",
                  loading: isLoading.value,
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, "Отчёт уже отправлен"))
        ]),
        _createVNode(_unref(ElDialog), {
          modelValue: isShowDialog.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowDialog).value = $event)),
          width: "400"
        }, {
          header: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: `/api/web/admin/patients/${_unref(patientId)}/get-qr`,
              alt: "qrCode"
            }, null, 8, _hoisted_9)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})